// Fechas del chat. Llegan en hora local, sin zona ("2026-10-31T10:32:00"), igual que
// las notificaciones: new Date() las lee tal cual.

const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

const aFecha = (valor) => {
  const fecha = valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(fecha.getTime()) ? null : fecha;
};

const inicioDelDia = (fecha) => new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
const diasEntre = (antes, despues) => Math.round((inicioDelDia(despues) - inicioDelDia(antes)) / 86400000);
const dosDigitos = (numero) => String(numero).padStart(2, "0");

/** "9:05 a. m.", "4:30 p. m." */
export const horaCorta = (valor) => {
  const fecha = aFecha(valor);
  if (!fecha) return "";
  const horas = fecha.getHours();
  return `${horas % 12 || 12}:${dosDigitos(fecha.getMinutes())} ${horas < 12 ? "a. m." : "p. m."}`;
};

/** Para la lista: la hora si es de hoy, "Ayer", el día de la semana o "12/10". */
export const cuandoCorto = (valor, ahora = new Date()) => {
  const fecha = aFecha(valor);
  if (!fecha) return "";
  const dias = diasEntre(fecha, ahora);
  if (dias <= 0) return horaCorta(fecha);
  if (dias === 1) return "Ayer";
  if (dias < 7) return DIAS[fecha.getDay()].replace(/^./, (letra) => letra.toUpperCase());
  return `${dosDigitos(fecha.getDate())}/${dosDigitos(fecha.getMonth() + 1)}${fecha.getFullYear() !== ahora.getFullYear() ? `/${fecha.getFullYear()}` : ""}`;
};

/** Separador entre días de la conversación: "Hoy", "Ayer", "12 de octubre". */
export const etiquetaDia = (valor, ahora = new Date()) => {
  const fecha = aFecha(valor);
  if (!fecha) return "";
  const dias = diasEntre(fecha, ahora);
  if (dias <= 0) return "Hoy";
  if (dias === 1) return "Ayer";
  const base = `${fecha.getDate()} de ${MESES[fecha.getMonth()]}`;
  return fecha.getFullYear() === ahora.getFullYear() ? base : `${base} de ${fecha.getFullYear()}`;
};

export const mismoDia = (uno, otro) => {
  const a = aFecha(uno);
  const b = aFecha(otro);
  return Boolean(a && b) && diasEntre(a, b) === 0;
};

/** La hora de este navegador en el mismo formato que manda el API (para lo que aún se envía). */
export const ahoraSinZona = (ahora = new Date()) =>
  `${ahora.getFullYear()}-${dosDigitos(ahora.getMonth() + 1)}-${dosDigitos(ahora.getDate())}T${dosDigitos(ahora.getHours())}:${dosDigitos(ahora.getMinutes())}:${dosDigitos(ahora.getSeconds())}`;
